import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';

const ecommerceNPS = () => import('../components/NPSecommerce.vue');
const groomingNPS = () => import('../components/NPSgrooming.vue');
const tiendaNPS = () => import('../components/NPStienda.vue');
const vetcoNPS = () => import('../components/NPSVetco.vue');
const bossNPS = () => import('../components/NPSBOSS.vue');
const bopusNPS = () => import('../components/NPSBOPUS.vue');
const preguntasE = () => import('../components/Preguntas.vue');
const preguntasG = () => import('../components/preguntasGrooming.vue');
const preguntasT = () => import('../components/PreguntasTienda.vue');
const preguntasBOSS = () => import('../components/preguntasBOSS.vue');
const preguntasBOPUS = () => import('../components/preguntasBOPUS.vue');
const notFound = () => import('../components/NotFound.vue');
const indicadoresNPS = () => import('../components/IndicadorNPS.vue');
const indicadorTiendas = () => import('../components/IndicadorTiendas.vue');
const indicadorGrooming = () => import('../components/IndicadorGrooming.vue');
const indicadorEcommerce = () => import('../components/IndicadorEcommerce.vue');
const indicadorBoss = () => import('../components/IndicadorBoss.vue');
const indicadorBopus = () => import('../components/IndicadorBopus.vue');
const NPSChat = () => import('../components/NPSChatEcommerce.vue');
const Encuesta = () => import('../components/Encuesta.vue');
const Easybuy = () => import('../components/Easybuy.vue');
const VitalCare = () => import('../components/VitalCare.vue')


Vue.use(VueRouter);


function isDefined(param: any) {
  return param !== null && param !== undefined && param !== '';
}

const routes = [
  // {
  //   path: '*',
  //   name: 'notfound',
  //   component: notFound,
  // },
  /** RUTAS ECOMMERCE */
  {
    path: '/ecommerce',
    name: 'ecommerce',
    component: ecommerceNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      if (isDefined(store.getters.idUser)) {
        next();
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/ecommerce/:id',
    name: 'ecommerceNPS',
    component: ecommerceNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      if (isDefined(usuario)) {
        store.dispatch('ClienteByClubPetco', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', usuario);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        }); 
      }
    },
  },
  {
    path: '/ecommerce/:id/:rating',
    name: 'ecommerceIdRat',
    component: ecommerceNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        }); 
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/ecommerce/:id/:rating/:empleado',
    name: 'ecommerceIdEmp',
    component: ecommerceNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let empleado = to.params.empleado;
      let rating = parseInt(to.params.rating);
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        store.dispatch('ClienteByClubPetco', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', usuario);
            store.commit('puntaje', rating);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            store.commit('idEmpleado', empleado)
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        }); 
      }
    },
  },

  // Encuesta

  {
    path: '/encuesta/:usuario',
    name: 'encuesta',
    component: Encuesta,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.usuario;
      if (isDefined(usuario)) {
        store.commit('idUser', usuario);
        next();
      } else {
        next('/unauthorized');
      }
    },
  },
  
  {
    path: '/encuesta_covid/:usuario',
    name: 'encuesta_covid',
    component: Encuesta,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.usuario;
      if (isDefined(usuario)) {
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            next();
          } else {
            next('/unauthorized');
          }
        });
      } else {
        next('/unauthorized');
      }
    },
  },


  {
    path: '/preguntas',
    name: 'preguntas',
    component: preguntasE,
    beforeEnter: (to: any, from: any, next: any) => {
      if (isDefined(store.state.preguntas)) {
        next();
      } else {
        next('/unauthorized');
      }
    },
  },
  /** RUTAS CHAT */
  {
    path: '/chat',
    name: 'chat',
    component: NPSChat,
    beforeEnter: (to: any, from: any, next: any) => {
      store.commit('idUser', '7501');
      if (isDefined(store.getters.idUser)) {
        next();
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/chat/:id',
    name: 'chatNPSID',
    component: NPSChat,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      if (isDefined(usuario)) {
        store.dispatch('ClienteByClubPetco', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', usuario);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        }); 
      }
    },
  },
  {
    path: '/chat/:id/:rating',
    name: 'chatIdRat',
    component: NPSChat,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        }); 
      } else {
        next('/unauthorized');
      }
    },
  },
  /** RUTAS GROOMING */
  {
    path: '/grooming',
    name: 'grooming',
    component: groomingNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      if (isDefined(store.getters.idUser)) {
        next();
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/grooming/:id',
    name: 'groomingNPS',
    component: groomingNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let tienda = to.params.id;
      store.commit('idUser', tienda);
      store.dispatch('GetTienda', tienda)
      .then ((respuesta) => {
        store.commit('nombreTienda', respuesta);
        next();
      }) 
      .catch (() => {
        next('/unauthorized');
      });
    },
  },
  {
    path: '/grooming/:id/:rating',
    name: 'groomingIdRat',
    component: groomingNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // store.commit('idUser', undefined);
        // store.commit('idUser', '29200151893812');
        // store.commit('puntaje', rating);
        // store.commit('nombreCliente', 'Victor');
        // next();
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/grooming/:idTienda/:id/:empleado',
    name: 'groomingIdRatE',
    component: groomingNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let idTienda = to.params.idTienda;
      let empleado = to.params.empleado;
      if (isDefined(usuario)) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClienteByClubPetco', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', usuario);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            store.commit('idEmpleado', empleado)
            store.dispatch('GetTienda', idTienda)
            .then ((respuesta) => {
              store.commit('nombreTienda', respuesta);
              next();
            }) 
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/grooming/:fecha/:consecutivo/:id/:rating',
    name: 'groomingFecIdRat',
    component: groomingNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      let fecha = to.params.fecha;
      let consecutivo = to.params.consecutivo;
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            store.commit('fechaCita', fecha);
            store.commit('consecutivo', consecutivo);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/preguntas_g',
    name: 'preguntasG',
    component: preguntasG
  },
  {
    path: '/tienda/:id',
    name: 'tienda',
    component: tiendaNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let tienda = to.params.id;
      store.commit('idUser', tienda);
      store.dispatch('GetTienda', tienda)
      .then ((respuesta) => {
        store.commit('nombreTienda', respuesta);
        next();
      }) 
      .catch (() => {
        next('/unauthorized');
      });
    },
  },
  {
    path: '/tienda/:id/:rating',
    name: 'tiendaIdRat',
    component: tiendaNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/tienda/:idTienda/:id/:rating',
    name: 'tiendaNombreTiendaIdRat',
    component: tiendaNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let idTienda = to.params.idTienda;
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            store.commit('idTienda', idTienda);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            store.dispatch('GetTienda', idTienda)
            .then ((respuesta) => {
              store.commit('nombreTienda', respuesta);
              next();
            }) 
            // next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/tiendas/:idTienda/:fecha/:id/:rating',
    name: 'tiendaNombreTiendaIdRatFecha',
    component: tiendaNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let idTienda = to.params.idTienda;
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      let fecha = to.params.fecha;
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            store.commit('idTienda', idTienda);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            store.dispatch('GetTienda', idTienda)
            .then ((respuest) => {
              store.commit('nombreTienda', respuest);
              /* eslint-disable no-console */
              store.dispatch('GetTiendaInfo', {fecha: fecha, tienda: idTienda, idClubPetco: respuesta.rows[0].ID_CLIENTE})
              .then((result) => {
                store.commit('idUnico', result.idUnico)
                store.commit('idCitaGrooming', result.rows[0].TRANSACCION)
                next();
              })
            }) 
            // next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/easybuy/:orden/:fecha/:id/:rating',
    name: 'easybuy',
    component: Easybuy,
    beforeEnter: (to: any, from: any, next: any) => {
      //let idTienda = to.params.idTienda;
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      let fecha = to.params.fecha;
      let idOrden = to.params.orden
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            //store.commit('idTienda', idTienda);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            store.commit('idOrden', idOrden)
            store.commit('idUnico', idOrden);
            next()
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/vitalcare/:orden/:fecha/:id/:rating',
    name: 'vitalcare',
    component: VitalCare,
    beforeEnter: (to: any, from: any, next: any) => {
      //let idTienda = to.params.idTienda;
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      let fecha = to.params.fecha;
      let idOrden = to.params.orden
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            //store.commit('idTienda', idTienda);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            store.commit('idOrden', idOrden)
            store.commit('idUnico', idOrden);
            next()
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/tienda/:idTienda/:id/:rating/:empleado',
    name: 'tiendaNombreTiendaIdEmp',
    component: tiendaNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let idTienda = to.params.idTienda;
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      let empleado = to.params.empleado;
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClienteByClubPetco', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            console.log(respuesta.rows[0]);
            // store.commit('idUser', undefined);
            store.commit('idUser', usuario);
            store.commit('puntaje', rating);
            store.commit('idTienda', idTienda);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            store.commit('idEmpleado', empleado)
            store.dispatch('GetTienda', idTienda)
            .then ((respuesta) => {
              store.commit('nombreTienda', respuesta);
              next();
            }) 
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        }); 
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/preguntas_t',
    name: 'preguntasT',
    component: preguntasT
  },

  /** RUTAS VETCO */
  {
  path: '/vetco/:idTienda/:idEmarsys/:idTransaccion/:rating',
  name: 'vetcoNPS',
  component: vetcoNPS,
  beforeEnter: (to: any, from: any, next: any) => {
    const idTienda = to.params.idTienda;
    const idEmarsys = to.params.idEmarsys;
    const idTransaccion = to.params.idTransaccion;
    const rating = parseInt(to.params.rating, 10);

    console.log('[VETCO] params:', { idTienda, idEmarsys, idTransaccion, rating });

    const idEmarsysNum = Number(idEmarsys);
    if (!idEmarsys || Number.isNaN(idEmarsysNum) || Number.isNaN(rating) || rating > 10) {
      console.log('[VETCO] validación fallida');
      return next('/unauthorized');
    }

    store.dispatch('ClubPetcoByIdEmarsys', idEmarsys)
      .then((respuesta: any) => {
        console.log('[VETCO] backend response', respuesta);

        // normaliza la fuente de filas
        const rows = respuesta && (respuesta.rows || respuesta.data || respuesta.result || []);
        if (rows && rows.length > 0) {
          store.commit('idUser', rows[0].ID_CLIENTE);
          store.commit('puntaje', rating);
          store.commit('idTienda', idTienda);
          store.commit('nombreCliente', rows[0].NOMBRE);
          store.commit('paisCliente', rows[0].PAIS);
          store.commit('idCitaGrooming', idTransaccion);

          return store.dispatch('GetTienda', idTienda)
            .then((res: any) => {
              store.commit('nombreTienda', res);
              next();
            })
            .catch((err: any) => {
              console.error('[VETCO] GetTienda error', err);
              next('/unauthorized');
            });
        } else {
          // FALLBACK: no hay filas. LOG y decide comportamiento.
          console.warn('[VETCO] no rows returned for idEmarsys', idEmarsys);

          // Opción A (permite acceso con idEmarsys como idUser):
          store.commit('idUser', idEmarsys);
          store.commit('puntaje', rating);
          store.commit('idTienda', idTienda);
          store.commit('idCitaGrooming', idTransaccion);
          // intenta obtener nombre de tienda igual que antes
          return store.dispatch('GetTienda', idTienda)
            .then((res: any) => {
              store.commit('nombreTienda', res);
              next();
            })
            .catch((err: any) => {
              console.error('[VETCO] GetTienda error (fallback)', err);
              next('/unauthorized');
            });

          // Opción B (alternativa): next('/unauthorized');
        }
      })
      .catch((err: any) => {
        console.error('[VETCO] ClubPetcoByIdEmarsys error', err);
        next('/unauthorized');
      });
  },
},

  /** RUTA VETCO DESARROLLO - Solo para pruebas */
  {
    path: '/vetco-dev',
    name: 'vetcoDesarrollo',
    component: vetcoNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      // Datos simulados para desarrollo
      store.commit('idUser', '12345678');
      store.commit('puntaje', -1);
      store.commit('idTienda', '1234');
      store.commit('nombreCliente', 'Cliente Prueba');
      store.commit('paisCliente', 'MX');
      store.commit('nombreTienda', 'Vetco San Ángel');
      store.commit('idCitaGrooming', 'TXN999');
      next();
    },
  },

  /** RUTAS BOPUS */
  {
    path: '/bopus',
    name: 'bopus',
    component: bopusNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      if (isDefined(store.getters.idUser)) {
        next();
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/bopus/:id',
    name: 'bopusNPS',
    component: bopusNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      if (isDefined(usuario)) {
        store.dispatch('ClienteByClubPetco', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            console.log(respuesta.rows[0]);
            store.commit('idUser', undefined);
            store.commit('idUser', usuario);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        }); 
      }
    },
  },
  {
    path: '/bopus/:id/:empleado',
    name: 'bopusIdRat',
    component: bopusNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let empleado = to.params.empleado;
      if (isDefined(usuario)) {
        store.dispatch('ClienteByClubPetco', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            console.log(respuesta.rows[0]);
            store.commit('idUser', usuario);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            store.commit('idEmpleado', empleado);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        }); 
      }
    },
  },
  {
    path: '/bopus/:fecha/:id/:rating',
    name: 'bopusFechaIdRat',
    component: bopusNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      let fecha = to.params.fecha;
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            console.log(respuesta.rows[0]);
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            let datos = {
              idClubPetco: store.getters.idUser,
              fecha: fecha
            };
            /* eslint-disable no-console */
            // console.log(datos)
            store.dispatch('GetBOPUSData', datos)
            .then((respues) => {
              if (respues.rows.length > 0) {
                store.commit('idCitaGrooming', respues.rows[0].IDCART);
                store.commit('idTienda', respues.rows[0].IDTIENDA);
                store.commit('idUnico', respues.idUnico);
                next();
              } else {
                next();
              }
            })
            .catch((err) => {
              next();
            })
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/preguntas_bopus',
    name: 'preguntasBOPUS',
    component: preguntasBOPUS
  },

  /** RUTAS BOSS */
  {
    path: '/boss',
    name: 'boss',
    component: bossNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      if (isDefined(store.getters.idUser)) {
        next();
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/boss/:id',
    name: 'bossNPS',
    component: bossNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      if (isDefined(usuario)) {
        store.dispatch('ClienteByClubPetco', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            console.log(respuesta.rows[0]);
            store.commit('idUser', undefined);
            store.commit('idUser', usuario);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        }); 
      }
    },
  },
  {
    path: '/boss/:id/:empleado',
    name: 'bossIdRat',
    component: bossNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let empleado = to.params.empleado;
      if (isDefined(usuario)) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClienteByClubPetco', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            console.log(respuesta.rows[0]);
            store.commit('idUser', usuario);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            store.commit('idEmpleado', empleado);
            next();
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        }); 
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/boss/:fecha/:id/:rating',
    name: 'bossFechaIdRat',
    component: bossNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      let fecha = to.params.fecha;
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            console.log(respuesta.rows[0]);
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            let datos = {
              idClubPetco: store.getters.idUser,
              fecha: fecha
            };
            /* eslint-disable no-console */
            // console.log(datos)
            store.dispatch('GetBOSSData', datos)
            .then((respues) => {
              if (respues.rows.length > 0) {
                store.commit('idCitaGrooming', respues.rows[0].IDCART);
                store.commit('idTienda', respues.rows[0].IDTIENDA);
                next();
              } else {
                next();
              }
            })
            .catch((err) => {
              next();
            })
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/boss/:fecha/:tienda/:id/:rating',
    name: 'bossFechaIdRatTiend',
    component: bossNPS,
    beforeEnter: (to: any, from: any, next: any) => {
      let usuario = to.params.id;
      let rating = parseInt(to.params.rating);
      let fecha = to.params.fecha;
      let tienda = to.params.tienda;
      if (isDefined(usuario) && isDefined(rating) && !isNaN(usuario) && !isNaN(rating) && rating <= 10) {
        // Recuperamos ID Club Petco de acuerdo al ID de emarsys
        store.dispatch('ClubPetcoByIdEmarsys', usuario)
        .then ((respuesta) => {
          if (respuesta.rows.length > 0) {
            console.log(respuesta.rows[0]);
            store.commit('idUser', undefined);
            store.commit('idUser', respuesta.rows[0].ID_CLIENTE);
            store.commit('puntaje', rating);
            store.commit('nombreCliente', respuesta.rows[0].NOMBRE);
            store.commit('paisCliente', respuesta.rows[0].PAIS);
            let datos = {
              idClubPetco: store.getters.idUser,
              fecha: fecha,
              tienda: tienda
            };
            /* eslint-disable no-console */
            // console.log(datos)
            store.dispatch('GetBOSSData', datos)
            .then((respues) => {
              if (respues.rows.length > 0) {
                store.commit('idCitaGrooming', respues.rows[0].IDCART);
                store.commit('idTienda', tienda);
                store.commit('idUnico', respues.idUnico)
                next();
              } else {
                next();
              }
            })
            .catch((err) => {
              next();
            })
          } else {
            next('/unauthorized');
          }
        })
        .catch (() => {
          next('/unauthorized');
        });
      } else {
        next('/unauthorized');
      }
    },
  },
  {
    path: '/preguntas_boss',
    name: 'preguntasBOSS',
    component: preguntasBOSS
  },
  {
    path: '/indicadores',
    name: 'indicadores',
    component: indicadoresNPS
  },
  {
    path: '/indicadorTiendas',
    name: 'indicadorTiendas',
    component: indicadorTiendas
  },
  {
    path: '/indicadorGrooming',
    name: 'indicadorGrooming',
    component: indicadorGrooming
  },
  {
    path: '/indicadorEcommerce',
    name: 'indicadorEcommerce',
    component: indicadorEcommerce
  },
  {
    path: '/indicadorBoss',
    name: 'indicadorBoss',
    component: indicadorBoss
  },
  {
    path: '/indicadorBopus',
    name: 'indicadorBopus',
    component: indicadorBopus
  },

  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: notFound // puedes crear Unauthorized.vue y usarlo aquí
  },

  // catch-all: siempre al final
  {
    path: '*',
    name: 'notfound',
    component: notFound,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router